"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncDefaultReportMessage = exports.defaultReportMessage = exports.asyncReportRunDetails = exports.reportRunDetails = void 0;

var stringify_1 = require("../../../utils/stringify");

var VerbosityLevel_1 = require("../configuration/VerbosityLevel");

var ExecutionStatus_1 = require("../reporter/ExecutionStatus");

function formatHints(hints) {
  if (hints.length === 1) {
    return "Hint: ".concat(hints[0]);
  }

  return hints.map(function (h, idx) {
    return "Hint (".concat(idx + 1, "): ").concat(h);
  }).join('\n');
}

function formatFailures(failures, stringifyOne) {
  return "Encountered failures were:\n- ".concat(failures.map(stringifyOne).join('\n- '));
}

function formatExecutionSummary(executionTrees, stringifyOne) {
  var summaryLines = [];
  var remainingTreesAndDepth = [];

  var _iterator = _createForOfIteratorHelper(executionTrees.slice().reverse()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _tree = _step.value;
      remainingTreesAndDepth.push({
        depth: 1,
        tree: _tree
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  while (remainingTreesAndDepth.length !== 0) {
    var currentTreeAndDepth = remainingTreesAndDepth.pop();
    var currentTree = currentTreeAndDepth.tree;
    var currentDepth = currentTreeAndDepth.depth;
    var statusIcon = currentTree.status === ExecutionStatus_1.ExecutionStatus.Success ? "\x1B[32m\u221A\x1B[0m" : currentTree.status === ExecutionStatus_1.ExecutionStatus.Failure ? '\x1b[31m\xD7\x1b[0m' : '\x1b[33m!\x1b[0m';
    var leftPadding = Array(currentDepth).join('. ');
    summaryLines.push("".concat(leftPadding).concat(statusIcon, " ").concat(stringifyOne(currentTree.value)));

    var _iterator2 = _createForOfIteratorHelper(currentTree.children.slice().reverse()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var tree = _step2.value;
        remainingTreesAndDepth.push({
          depth: currentDepth + 1,
          tree: tree
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return "Execution summary:\n".concat(summaryLines.join('\n'));
}

function preFormatTooManySkipped(out, stringifyOne) {
  var message = "Failed to run property, too many pre-condition failures encountered\n{ seed: ".concat(out.seed, " }\n\nRan ").concat(out.numRuns, " time(s)\nSkipped ").concat(out.numSkips, " time(s)");
  var details = null;
  var hints = ['Try to reduce the number of rejected values by combining map, flatMap and built-in arbitraries', 'Increase failure tolerance by setting maxSkipsPerRun to an higher value'];

  if (out.verbose >= VerbosityLevel_1.VerbosityLevel.VeryVerbose) {
    details = formatExecutionSummary(out.executionSummary, stringifyOne);
  } else {
    hints.push('Enable verbose mode at level VeryVerbose in order to check all generated values and their associated status');
  }

  return {
    message: message,
    details: details,
    hints: hints
  };
}

function preFormatFailure(out, stringifyOne) {
  var message = "Property failed after ".concat(out.numRuns, " tests\n{ seed: ").concat(out.seed, ", path: \"").concat(out.counterexamplePath, "\", endOnFailure: true }\nCounterexample: ").concat(stringifyOne(out.counterexample), "\nShrunk ").concat(out.numShrinks, " time(s)\nGot error: ").concat(out.error);
  var details = null;
  var hints = [];

  if (out.verbose >= VerbosityLevel_1.VerbosityLevel.VeryVerbose) {
    details = formatExecutionSummary(out.executionSummary, stringifyOne);
  } else if (out.verbose === VerbosityLevel_1.VerbosityLevel.Verbose) {
    details = formatFailures(out.failures, stringifyOne);
  } else {
    hints.push('Enable verbose mode in order to have the list of all failing values encountered during the run');
  }

  return {
    message: message,
    details: details,
    hints: hints
  };
}

function preFormatEarlyInterrupted(out, stringifyOne) {
  var message = "Property interrupted after ".concat(out.numRuns, " tests\n{ seed: ").concat(out.seed, " }");
  var details = null;
  var hints = [];

  if (out.verbose >= VerbosityLevel_1.VerbosityLevel.VeryVerbose) {
    details = formatExecutionSummary(out.executionSummary, stringifyOne);
  } else {
    hints.push('Enable verbose mode at level VeryVerbose in order to check all generated values and their associated status');
  }

  return {
    message: message,
    details: details,
    hints: hints
  };
}

function defaultReportMessageInternal(out, stringifyOne) {
  if (!out.failed) return;

  var _ref = out.counterexamplePath === null ? out.interrupted ? preFormatEarlyInterrupted(out, stringifyOne) : preFormatTooManySkipped(out, stringifyOne) : preFormatFailure(out, stringifyOne),
      message = _ref.message,
      details = _ref.details,
      hints = _ref.hints;

  var errorMessage = message;
  if (details != null) errorMessage += "\n\n".concat(details);
  if (hints.length > 0) errorMessage += "\n\n".concat(formatHints(hints));
  return errorMessage;
}

function defaultReportMessage(out) {
  return defaultReportMessageInternal(out, stringify_1.stringify);
}

exports.defaultReportMessage = defaultReportMessage;

function asyncDefaultReportMessage(_x) {
  return _asyncDefaultReportMessage.apply(this, arguments);
}

function _asyncDefaultReportMessage() {
  _asyncDefaultReportMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(out) {
    var pendingStringifieds, stringifyOne, firstTryMessage, registeredValues, stringifySecond;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            stringifySecond = function _stringifySecond(value) {
              var asyncStringifiedIfRegistered = registeredValues.get(value);

              if (asyncStringifiedIfRegistered !== undefined) {
                return asyncStringifiedIfRegistered;
              }

              return (0, stringify_1.stringify)(value);
            };

            stringifyOne = function _stringifyOne(value) {
              var stringified = (0, stringify_1.possiblyAsyncStringify)(value);

              if (typeof stringified === 'string') {
                return stringified;
              }

              pendingStringifieds.push(Promise.all([value, stringified]));
              return "\u2026";
            };

            pendingStringifieds = [];
            firstTryMessage = defaultReportMessageInternal(out, stringifyOne);

            if (!(pendingStringifieds.length === 0)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", firstTryMessage);

          case 6:
            _context.t0 = Map;
            _context.next = 9;
            return Promise.all(pendingStringifieds);

          case 9:
            _context.t1 = _context.sent;
            registeredValues = new _context.t0(_context.t1);
            return _context.abrupt("return", defaultReportMessageInternal(out, stringifySecond));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _asyncDefaultReportMessage.apply(this, arguments);
}

exports.asyncDefaultReportMessage = asyncDefaultReportMessage;

function throwIfFailed(out) {
  if (!out.failed) return;
  throw new Error(defaultReportMessage(out));
}

function asyncThrowIfFailed(_x2) {
  return _asyncThrowIfFailed.apply(this, arguments);
}

function _asyncThrowIfFailed() {
  _asyncThrowIfFailed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(out) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (out.failed) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            _context2.t0 = Error;
            _context2.next = 5;
            return asyncDefaultReportMessage(out);

          case 5:
            _context2.t1 = _context2.sent;
            throw new _context2.t0(_context2.t1);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _asyncThrowIfFailed.apply(this, arguments);
}

function reportRunDetails(out) {
  if (out.runConfiguration.asyncReporter) return out.runConfiguration.asyncReporter(out);else if (out.runConfiguration.reporter) return out.runConfiguration.reporter(out);else return throwIfFailed(out);
}

exports.reportRunDetails = reportRunDetails;

function asyncReportRunDetails(_x3) {
  return _asyncReportRunDetails.apply(this, arguments);
}

function _asyncReportRunDetails() {
  _asyncReportRunDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(out) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!out.runConfiguration.asyncReporter) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", out.runConfiguration.asyncReporter(out));

          case 4:
            if (!out.runConfiguration.reporter) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", out.runConfiguration.reporter(out));

          case 8:
            return _context3.abrupt("return", asyncThrowIfFailed(out));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _asyncReportRunDetails.apply(this, arguments);
}

exports.asyncReportRunDetails = asyncReportRunDetails;